
export const urlVarsHelper = { getUrlVars, };

function getUrlVars(queryString?: string): any {
    const source = typeof queryString === "string"
        ? queryString
        : window.location.search;
    const normalizedQuery = source.startsWith("?") ? source.substring(1) : source;
    const params: Record<string, string> = {};

    if (!normalizedQuery) {
        return params;
    }

    const searchParams = new URLSearchParams(normalizedQuery);
    searchParams.forEach((value, key) => {
        params[key] = value;
    });

    return params;
}